"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FancyboxManager = void 0;
const fancybox_esm_js_1 = require("@fancyapps/ui/dist/fancybox/fancybox.esm.js");
class FancyboxManager {
    static initialize() {
        fancybox_esm_js_1.Fancybox.bind('[data-fancybox]', {
        // Your custom options
        });
    }
}
exports.FancyboxManager = FancyboxManager;
